import { Button } from '@altibox/design-system-component-lib';
import { styled, css } from 'styled-components';

import { Image } from 'src/components/image';
import { spacing1 } from 'src/styles/spacing';

const iconLeftStyles = css`
  margin: 0 ${spacing1} 0 0;
`;

const iconRightStyles = css`
  margin: 0 0 0 ${spacing1};
`;

export const StyledIcon = styled(Image)`
  /* placeholder */
`;

export const StyledButton = styled(Button)`
  margin: 0;

  span {
    /* stylelint-disable-next-line declaration-no-important */
    margin: 0 !important;
  }

  ${StyledIcon} {
    ${(props) => (props.iconWrapper?.placeIconBeforeText ? iconLeftStyles : iconRightStyles)}
  }
`;
